import { render, staticRenderFns } from "./AdminReservations.vue?vue&type=template&id=aca2d1c0"
import script from "./AdminReservations.vue?vue&type=script&lang=js"
export * from "./AdminReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports